import { useMutation } from "@tanstack/react-query";
import { message } from "antd";

import { axios, getBackendApiErrorResponse } from "~/core/axios";
import { getQueryClient } from "~/core/react-query/utils";

type UseSwitchWorkspaceParams = {
  redirectTo?: string;
};

export const useSwitchWorkspace = ({
  redirectTo,
}: UseSwitchWorkspaceParams = {}) => {
  const { mutateAsync, isPending } = useMutation({
    mutationFn: async (org_id: string) => {
      message.loading({
        content: "Switching workspace...",
        key: "switchWorkspace",
      });
      try {
        await axios.post("/membership/switch-organization", {
          org_id,
        });
      } catch (error) {
        const err = getBackendApiErrorResponse(error);
        throw err.data.message;
      }
    },
    onSuccess: () => {
      setTimeout(() => {
        const queryClient = getQueryClient();
        queryClient.invalidateQueries();
        if (redirectTo) {
          window.location.href = redirectTo;
        } else {
          window.location.reload();
        }
      }, 500);
      sessionStorage.clear();
    },
    onError: err => {
      message.error({ content: err.message, key: "switchWorkspace" });
    },
  });

  return { switchWorkspace: mutateAsync, isSwitchWorkspacePending: isPending };
};
